import { useMemo } from 'react';

/**
 * Custom hook to check if the user has a single avatar wallet.
 * @function useHasSingleAvatarWallet
 * @param {string[]} avatarWallets - The list of avatar wallet addresses.
 * @returns {boolean} True if the user has a single avatar wallet, false otherwise.
 */
export const useHasSingleAvatarWallet = (avatarWallets: string[]) => {
  return useMemo(() => avatarWallets?.length === 1, [avatarWallets]);
};
